import { render, staticRenderFns } from "./BelposhtaEditingPage.vue?vue&type=template&id=367146dd"
import script from "./BelposhtaEditingPage.vue?vue&type=script&lang=js"
export * from "./BelposhtaEditingPage.vue?vue&type=script&lang=js"
import style0 from "./BelposhtaEditingPage.vue?vue&type=style&index=0&id=367146dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports